import React, { useState, useEffect } from 'react'
import * as PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import styled from 'styled-components'
import { MdClose } from '@react-icons/all-files/md/MdClose'
import UnstyledButton from 'components/button/unstyled-button'
import useMedia from 'react-use/lib/useMedia'
import noop from 'utils/noop'

const defaultStyle = {
  content: {
    backgroundColor: '#fff',
    border: 'none',
    borderRadius: 'none',
    bottom: 'auto',
    height: '100%',
    left: '50%',
    overflowY: 'scroll',
    padding: '80px 25px',
    position: 'absolute',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '9999',
  },
}

const desktopStyle = {
  content: {
    ...defaultStyle.content,
    height: 'auto',
    maxHeight: '90%',
    maxWidth: '900px',
    overflowY: 'auto',
    padding: '60px 75px',
  },
  overlay: {
    ...defaultStyle.overlay,
  },
}

ReactModal.setAppElement('#___gatsby')

const Modal = ({ children, isOpen, onRequestClose, style, toggle, ...props }) => {
  const isDesktop = useMedia('(min-width: 800px)')
  const [modalStyle, setModalStyle] = useState(defaultStyle)

  useEffect(() => {
    if (isDesktop) {
      setModalStyle(desktopStyle)
    } else {
      setModalStyle(defaultStyle)
    }
  }, [isDesktop])

  const closeModal = () => {
    toggle(false)
  }

  const handleRequestClose = () => {
    closeModal()
    onRequestClose()
  }
  return (
    <ReactModal style={modalStyle} isOpen={isOpen} onRequestClose={handleRequestClose} {...props}>
      {children}
      <Close onClick={closeModal} aria-label='Close'>
        <MdClose aria-hidden='true' focusable='false' role='presentation' />
      </Close>
    </ReactModal>
  )
}

Modal.propTypes = {
  aria: PropTypes.object,
  ariaHideApp: PropTypes.bool,
  bodyOpenClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeTimeoutMS: PropTypes.number,
  contentLabel: PropTypes.string,
  contentRef: PropTypes.func,
  data: PropTypes.object,
  htmlOpenClassName: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onAfterClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func,
  overlayClassName: PropTypes.string,
  overlayRef: PropTypes.func,
  parentSelector: PropTypes.func,
  portalClassName: PropTypes.string,
  role: PropTypes.string,
  shouldCloseOnEsc: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldFocusAfterRender: PropTypes.bool,
  shouldReturnFocusAfterClose: PropTypes.bool,
  style: PropTypes.shape({
    overlay: PropTypes.object,
    content: PropTypes.object,
  }),
  toggle: PropTypes.func.isRequired,
}

Modal.defaultProps = {
  onRequestClose: noop,
}

const Close = styled(UnstyledButton)`
  color: #444;
  cursor: pointer;
  font-size: 2em;
  position: absolute;
  right: 20px;
  top: 20px;
`

export default Modal
